// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"728":"535e4519d8286c863cf2","992":"b97a650475f1bfc829cd"}[chunkId] + ".bundle.js";
};